import { useMutation } from "@tanstack/react-query";
import { fetchRfxSummaryPreviewHtml } from "../api/rfx-report-api";
import type { RfxSummaryPreviewParams, RfxReportPreviewHtmlResponse } from "../types";

export const useRfxSummaryPreviewHtml = () => {
	return useMutation<RfxReportPreviewHtmlResponse, Error, { params: RfxSummaryPreviewParams; rfxId: number; }>({
		mutationFn: ({ rfxId, params }) => fetchRfxSummaryPreviewHtml(rfxId, params),
	});
};
